import { BreadcrumContext } from "@shared/components";
import { gql, useQuery } from "@shared/utils";
import { PropsWithChildren } from "react";
import { useProductVariables } from "../utils/nav";

export const BreadcrumProvider = ({ children }: PropsWithChildren<any>) => {
  const { category, product, setProduct, setCategory, setSubCategory } =
    useProductVariables();
  const items = [
    {
      title: "Products",
      onClick: () => {
        setProduct();
      },
      onRightClick: () => {
        setProduct(undefined, true);
      },
    },
  ];
  const productInfo = useQuery<{
    product?: {
      name: string;
      _id: string;
      ParentProduct: { name: string; _id: string };
    };
  }>(
    gql`
      query Product($product: String!) {
        product(id: $product) {
          name
          _id
          ParentProduct {
            _id
            name
          }
        }
      }
    `,
    { variables: { product }, skip: typeof product !== "string" || !product }
  );

  const categoryInfo = useQuery<{ category?: { name: string; _id: string } }>(
    gql`
      query Category($category: ID!) {
        category(_id: $category) {
          name
          _id
        }
      }
    `,
    { variables: { category }, skip: typeof category !== "string" || !category }
  );
  if (productInfo?.data?.product) {
    const product = productInfo?.data?.product;
    if (product?.ParentProduct) {
      items.push({
        title: product?.ParentProduct?.name,
        onClick: () => {
          setProduct(product?.ParentProduct._id);
        },
        onRightClick: () => {
          setProduct(product?.ParentProduct._id, true);
        },
      });
    }

    items.push({
      title: product?.name,
      onClick: () => {
        setProduct(product?._id);
      },
      onRightClick: () => {
        setProduct(product?._id, true);
      },
    });
  }

  if (categoryInfo?.data?.category) {
    items.push({
      title: categoryInfo?.data?.category?.name,
      onClick: () => {
        setCategory(categoryInfo?.data?.category?._id);
      },
      onRightClick: () => {
        setCategory(categoryInfo?.data?.category?._id, true);
      },
    });
  }

  return (
    <BreadcrumContext.Provider value={{ items }}>
      {children}
    </BreadcrumContext.Provider>
  );
};
